// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2NVw5","label":"Section_label__1VVCM","contentWrap":"Section_contentWrap__3xYSZ","footer":"Section_footer__33KMa","footerInner":"Section_footerInner__3V5OM"};